import React from 'react'
import styles from './EventMap.module.scss'
import { ButtonGroup } from '@/component/Primitive/Events'
import { array, object, string } from 'prop-types'
import BrandMap from '@/component/Primitive/Brand/component/BrandMap'

export const EventMap = ({ items, buttonGroup, title }) => {
  return (
    <div className={styles.EventMapWrapper}>
      <BrandMap stats={items} title={title} />
      {!!buttonGroup?.length && (
        <ButtonGroup group={buttonGroup} className={styles.Buttons} />
      )}
    </div>
  )
}

EventMap.propTypes = {
  items: array,
  buttonGroup: object,
  title: string
}
